import styled from "@emotion/styled";

import GrassAndDirt from "./grass-and-dirt.png";

export const MascotPangContainer = styled.div`
  inset-inline-start: 40%;
`;

export const StyledImg = styled.img`
  inline-size: 100%;
  block-size: 100%;
`;

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 28vw;

  background-image: url(${GrassAndDirt.src});
  background-position: center;
  background-size: cover;

  ${MascotPangContainer} {
    position: absolute;
    inset-block-end: 9vw;
    inset-inline-start: 36vw;

    inline-size: 7.87vw;
    block-size: 10.41vw;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-end: 25px;

    block-size: 295px;

    ${MascotPangContainer} {
      inset-block-end: 94px;
      inset-inline-start: calc(577.44px - 720px + 50vw);

      inline-size: 78.5px;
      block-size: 109.16px;
    }
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    block-size: 20.49vw;

    ${MascotPangContainer} {
      inset-block-end: 6.53vw;
      inset-inline-start: 40.5vw;

      inline-size: 5.45vw;
      block-size: 7.58vw;
    }
  }
`;
